// extracted by mini-css-extract-plugin
export default {"mod_lm_title":"index_mod_lm_title_vKvVI"};